import React, { useCallback, useEffect } from "react"
import { FaDeleteLeft } from "react-icons/fa6"
import { FaTimes } from "react-icons/fa"

import classes from "./KeyPads.module.scss"

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "پاک", "0", "del"]

const KeyPads = props => {
  const {
    type = "number",
    disableKeyboard = false,
    value,
    onChange
  } = props

  const handleCurrency = (key) => {
    if (key === "پاک") {
      return onChange(type === "text" ? "" : 0)
    }

    if (key === "del") {
      const string = String(value)

      if (type === "text") return onChange(string.substring(0, string.length - 1))

      const newSalePrice =
        Number(
          string.length === 1 || string.length === 0
            ? 0
            : string.substring(0, string.length - 1)
        )

      return onChange(newSalePrice)
    }

    const newSalePrice =
      type === "text" ? String(value + key) : Number(value + key)

    onChange(newSalePrice)
  }

  const handleKeyPress =
    useCallback((e) => {
      if (disableKeyboard) return

      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === "Delete") {
        key = "پاک"
      }

      if (key === "") return

      handleCurrency(key)
    }, [value, disableKeyboard])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [value, disableKeyboard])

  return (
    <div className={classes["container"]}>
      {keys.map(key =>
        <button
          key={key}
          className={classes["key"]}
          onClick={() => handleCurrency(key)}
        >
          {key === "del"
            ? <FaDeleteLeft />
            : key === "پاک" ? <FaTimes /> : key
          }
        </button>
      )}
    </div>
  )
}

export default KeyPads